import React from 'react';
import { Box, CircularProgress, Typography, useTheme } from '@mui/material';

export function LoadingFallback() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        gap: 2,
      }}
    >
      <CircularProgress
        size={48}
        sx={{
          color: theme.palette.primary.main,
        }}
      />
      <Typography variant="body2" color="text.secondary">
        Loading...
      </Typography>
    </Box>
  );
}
